module.exports = __webpack_public_path__ + "img/ming.c8a10fe1.png";